/*
 * --------------------------------------------------------------------------- *
 * File: edittype.js                                                           *
 * Project: web                                                                *
 * Created Date: 29 Oct 2022                                                   *
 * Author: Vikas K Solegaonkar (vikas.solegaonkar@gmail.com)                   *
 * Copyright (c) 2022 Vikas K Solegaonkar                                      *
 * https://solegaonkar.com                                                     *
 *                                                                             *
 * Last Modified: Mon Nov 07 2022                                              *
 * Modified By: Vikas K Solegaonkar                                            *
 *                                                                             *
 * HISTORY:                                                                    *
 * --------------------------------------------------------------------------- *
 * Date         By     Comments                                                *
 * --------------------------------------------------------------------------- *
 */
import React, { useContext, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import Constants from "../main/constants";
import { addSpaceBeforeCaps, replaceMicrosoftCharacters } from "../main/utilities";
import { updateDataType, createDataType, checkNameExists, getSampleValue, isJsonString } from "../data/datatypeutils";
import DataForm from "../data/dataform";
import { AppContext } from "../main/context";
import sha1 from "sha1";
import { ValidationManager } from "../data/validations";

function EditType() {
  const { selectedEditDataType, setShowNow } = useContext(AppContext);
  const [nameError, setNameError] = useState("");
  const [typeName, setTypeName] = useState(selectedEditDataType?.name);
  const [description, setDescription] = useState(selectedEditDataType?.description);
  const [typeString, setTypeString] = useState(
    selectedEditDataType?.structure
      ? JSON.stringify(selectedEditDataType.structure, null, 3)
      : JSON.stringify(Constants.newTypeTemplate, null, 3)
  );

  const [sampleString, setSampleString] = useState(
    selectedEditDataType?.structure
      ? JSON.stringify(getSampleValue(selectedEditDataType.structure), null, 3)
      : JSON.stringify(Constants.newTypeExample, null, 3)
  );

  const [message, setMessage] = useState("");
  const updateTypeString = (str) => {
    setSampleString("");
    try {
      setTypeString(str);
      const type = JSON.parse(str);
      // setTypeString(JSON.stringify(type, null, 3));
      setSampleString(JSON.stringify(getSampleValue(type), null, 3));
      setMessage("");
    } catch (e) {
      setMessage("Invalid Syntax");
    }
  };

  const save = async () => {
    if (!message && !nameError) {
      if (selectedEditDataType?.name) {
        await updateDataType({
          id: sha1(selectedEditDataType.name),
          name: typeName,
          description: description,
          structure: JSON.parse(typeString),
        });
      } else {
        await createDataType({
          name: sha1(typeName),
          description: description,
          structure: JSON.parse(typeString),
        });
      }
      setShowNow(Constants.SHOW_NOW_DATA_TYPE_LIST);
    }
  };

  const dataTypeName = () => {
    if (selectedEditDataType?.name) {
      return <h4 className="pt-4">{addSpaceBeforeCaps(selectedEditDataType.name)}</h4>;
    } else {
      return (
        <>
          <h3>Add new DataType</h3>
          <hr />
          <input
            type="text"
            className="wide p-2 mt-2 mb-2"
            placeholder="DataTypeName"
            value={typeName}
            onChange={(e) => {
              var val = e.target.value.replace(/\s+/g, "");
              setTypeName(val);
              if (!checkNameExists(val)) {
                setNameError("");
              } else {
                setNameError("Name clashes with existing Data Type");
              }
            }}
          />
          {nameError}
        </>
      );
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          {dataTypeName()}
          <input
            type="text"
            className="wide p-2 mt-2 mb-2"
            placeholder="More Information about Data Type"
            value={description}
            onChange={(e) => {
              setDescription(replaceMicrosoftCharacters(e.target.value));
            }}
          />
        </div>
        <div className="col-sm-6 left">
          <p>Provide the field details. Allowed field types: string, number, date, boolean</p>
          <textarea
            rows={20}
            className="wide  p-1 mt-0"
            value={typeString}
            onChange={(e) => {
              updateTypeString(e.target.value);
            }}
          ></textarea>
        </div>
        <div className="col-sm-6 left">
          <p>Effective Data Type. This is a sample JSON of the record for this data type</p>
          <textarea rows={20} className="wide p-1 mt-0" readOnly value={sampleString}></textarea>
        </div>
        <div className="col-12">
          <p>{message}</p>
        </div>
        <div className="col-6 left">
          <button className="btn bg-warning bg-gradient border border-dark shadow mb-2" onClick={(e) => save()}>
            Save
          </button>
        </div>
        <div className="col-6 right">
          <button
            className="btn bg-warning bg-gradient border border-dark shadow mb-2"
            onClick={(e) => setShowNow(Constants.SHOW_NOW_DATA_TYPE_LIST)}
          >
            Cancel
          </button>
        </div>
        <div className="col-12">
          <DataForm
            structure={isJsonString(typeString) ? JSON.parse(typeString) : []}
            data={isJsonString(sampleString) ? JSON.parse(sampleString) : {}}
            title="Sample Form"
            onChange={(v) => {
              setSampleString(JSON.stringify(v, null, 3));
            }}
            validation={new ValidationManager()}
          />
        </div>
      </div>
    </>
  );
}

export default EditType;
